import * as url from "../url_helper";

import { post } from "../api_helper";

export const addSystemConfiguration = data => post(url.ADD_SYSTEM_CONFIGURATION, data);

export const getSystemConfiguration = (data) => post(url.GET_SYSTEM_CONFIGURATION, data);

export const editSystemConfiguration = data => post(url.EDIT_SYSTEM_CONFIGURATION, data);

export const getSystemConfigurationById = data => post(url.GET_SYSTEM_CONFIGURATION_BY_ID, data);

export const getSystemConfigurationByKey = data => post(url.GET_SYSTEM_CONFIGURATION_BY_KEY, data);

export const uploadFile= data => {
    const formData = new FormData()
    formData.append("upl",data)
    return post(url.UPLOAD_FILE,formData,{headers:{
    'Content-Type':'multipart/form-data'
}})};

export const uploadImage= data => {
    const formData = new FormData()
    formData.append("upl",data)
    return post(url.UPLOAD_IMAGE,formData,{headers:{
    'Content-Type':'multipart/form-data'
}})};

export const downloadSystemConfigFile = data => post(url.DOWNLOAD_FILE, data);
